<!--
 @description 服务监控-应用性能-应用tab
 @author xiehan
 @date 2018/11/13
-->
<template>
  <div>
    <div style="margin-bottom: 10px;">
      <el-button type="primary" @click="getAppTime(1)" v-g-rac="gRac('appDetailApp_search')" v-text="$t('serverMonitor.today')"></el-button>
      <el-button type="primary" @click="getAppTime(1800000)" v-g-rac="gRac('appDetailApp_search')" v-text="$t('serverMonitor.thirtyMins')"></el-button>
      <el-button type="primary" @click="getAppTime(3600000)" v-g-rac="gRac('appDetailApp_search')" v-text="$t('serverMonitor.oneHour')"></el-button>
      <el-button type="primary" @click="getAppTime(10800000)" v-g-rac="gRac('appDetailApp_search')" v-text="$t('serverMonitor.threeHours')"></el-button>
      <el-button type="primary" @click="getAppTime(21600000)" v-g-rac="gRac('appDetailApp_search')" v-text="$t('serverMonitor.sixHours')"></el-button>
      <el-button type="primary" @click="getAppTime(43200000)" v-g-rac="gRac('appDetailApp_search')" v-text="$t('serverMonitor.twelveHours')"></el-button>
      <el-button type="primary" @click="getAppTime(2)" v-g-rac="gRac('appDetailApp_search')" v-text="$t('serverMonitor.yesterday')"></el-button>
    </div>
    <el-form ref="chartForm" :model="chartForm" label-width="40px" :inline="true" class="demo-form-inline">
      <el-form-item :label="$t('common.time')" input-width="auto">
        <el-form-item prop="startTime">
          <el-date-picker value-format="timestamp" style="width: 180px;" v-model="chartForm.startTime" type="datetime">
          </el-date-picker>
        </el-form-item>
        <span v-text="$t('common.to')"></span>
        <el-form-item prop="endTime" style="margin-left: 10px">
          <el-date-picker value-format="timestamp" style="width: 180px;" v-model="chartForm.endTime" type="datetime">
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('serverMonitor.hostIP')" prop="ip" label-width="60px">
          <g-select v-model="chartForm.ip" :list="select_ip"></g-select>
        </el-form-item>
        <el-form-item input-width="80px">
          <el-button type="primary" @click="getKpiMapping" v-g-rac="gRac('appDetailApp_search')" v-text="$t('common.search')"></el-button>
        </el-form-item>
      </el-form-item>
    </el-form>
    <ob-server-charts :query-parames="item" :index="index" v-for="(item, index) in chartDataList" :key="index + item.startTime + item.endTime"></ob-server-charts>
    <div v-show="this.chartDataList.length === 0" v-text="$t('common.noData')" style="text-align: center"></div>
  </div>
</template>

<script>
  import obServerCharts from '@/components/chart/obServerCharts'
  
  import rac from '@/plugins/rac-mixin'
  import KpiMappingBiz from '@/logic/systemSetting/kpiMappingBiz'
  import ITDeviceMonitorBiz from '@/logic/intelligentMonitor/ITDeviceMonitorBiz'
  import ServerMonitorBiz from '@/logic/intelligentMonitor/serverMonitorBiz'
  export default {
    mixins: [rac],
    data () {
      return {
        chartForm: {
          startTime: new Date(new Date().toLocaleDateString()).getTime(),
          endTime: '',
          ip: ''
        },
        select_ip: {},
        chartDataList: []
      }
    },
    components: {
      obServerCharts
    },
    props: ['app', 'group', 'ip', 'port', 'reset'],
    methods: {
      getAppTime (time) {
        if (Number(time) === 1) {
          this.chartForm.startTime = new Date(new Date().toLocaleDateString()).getTime()
          this.chartForm.endTime = new Date().getTime()
        } else if (Number(time) === 2) {
          this.chartForm.startTime = new Date(new Date().toLocaleDateString()).getTime() - 86400000
          this.chartForm.endTime = new Date(new Date().toLocaleDateString()).getTime()
        } else {
          this.chartForm.startTime = new Date().getTime() - Number(time)
          this.chartForm.endTime = new Date().getTime()
        }
        this.getKpiMapping()
      },
      getIpList () {
        ServerMonitorBiz.getIpList({ group: this.group, appName: this.app, siteCode: this.$route.query.siteCode}).then(res => {
          let ipObj = {}
          res.map(item => {
            ipObj[`${item.ip}:${item.port}`] = `${item.ip}:${item.port}`
          })
          this.select_ip = ipObj
          this.chartForm.ip = `${this.ip}:${this.port}`
          this.getKpiMapping()
        })
      },
      getKpiMapping () {
        KpiMappingBiz.getKpiMap({ group: this.group, appName: this.app, siteCode: this.$route.query.siteCode }).then(data => {
          let chartDataList = []
          data.map(item => {
            let alarm = !!item.alarm
            chartDataList.push(this.getChartParames(item.kpiKey, item.desc, alarm))
          })
          this.chartDataList = [...chartDataList]
        })
      },
      getChartParames (kpiKey, desc, alarm) {
        return {
          group: this.group,
          appName: this.app,
          ip: this.chartForm.ip.split(':')[0] ? this.chartForm.ip.split(':')[0] : '',
          port: this.chartForm.ip.split(':')[1] ? Number(this.chartForm.ip.split(':')[1]) : 0,
          siteCode: this.$route.query.siteCode,
          kpiKey: kpiKey,
          startTime: this.chartForm.startTime,
          endTime: this.chartForm.endTime ? this.chartForm.endTime : new Date().getTime(),
          desc,
          alarm
        }
      },
      getChartData (kpiKey, desc, alarm) {
        return new Promise((resolve, reject) => {
          ITDeviceMonitorBiz.getChartData({
            group: this.group,
            appName: this.app,
            ip: this.chartForm.ip.split(':')[0] ? this.chartForm.ip.split(':')[0] : '',
            port: this.chartForm.ip.split(':')[1] ? Number(this.chartForm.ip.split(':')[1]) : 0,
            siteCode: this.$route.query.siteCode,
            kpiKey: kpiKey,
            startTime: this.chartForm.startTime,
            endTime: this.chartForm.endTime ? this.chartForm.endTime : new Date().getTime()
          }).then(data => {
            resolve({
              title: desc,
              data: data,
              alarm: alarm,
              kpiInfo: {
                appGroup: this.group,
                appName: this.app,
                kpiKey: kpiKey,
                siteCode: this.$route.query.siteCode
              }
            })
          }).catch(err => {
            reject(err)
          })
        })
      },
      drawChart (dataList) {
        const list = []
        dataList.map((item, index) => {
          const chartData = {
            title: item.title,
            kpiInfo: item.kpiInfo,
            chartId: `chartGroups-serverAPP-${item.title}${index}`,
            chartData: {
              rows: item.data ? item.data : [],
              columns: ['eventTime', 'value'],
              alarm: item.alarm,
              formatMap: {
                eventTime: 'TIME'
              },
              labelMap: {
                value: item.title
              }
            }
          }
          list.push(chartData)
        })
        this.chartDataList = list
      }
    },
    watch: {
      reset (val) {
        this.chartForm.startTime = new Date(new Date().toLocaleDateString()).getTime()
        this.chartForm.endTime = ''
        this.getIpList()
      }
    }
  }
</script>

<style>

</style>